import html2canvas from 'html2canvas';

const capture = (event) => {
    document.querySelector("body").classList.add("edit_cursor");
    screenshot(event)
  }
  
const screenshot = (e)=>{
    try{
        var startX, startY,mousedownX;
        var height = window.innerHeight;
        var width = window.innerWidth;
        
        // 배경을 어둡게 깔아주기 위한 div 객체 생성
        var screenBg = document.createElement("div");
        screenBg.id = "screenshot_background";
        screenBg.style.borderWidth = "0 0 " + height + "px 0";
    
        // 마우스 이동하면서 선택한 영역의 크기를 보여주기 위한 div 객체 생성
        var screenshot = document.createElement("div");
        screenshot.id = "screenshot";
        
        document.querySelector("body").appendChild(screenBg);
        document.querySelector("body").appendChild(screenshot);
        
        var selectArea = false;
        var body = document.querySelector('body');
    
        // 마우스 누르는 이벤트 함수
        var mousedown = function(e) {
            e.preventDefault();
            selectArea = true;
            startX = e.clientX;
            startY = e.clientY;
            // mousedownX = e.screenX
            // 이벤트를 실행하면서 이벤트 삭제 (한번만 동작하도록)
            body.removeEventListener("mousedown", mousedown);
        }
        // 마우스 누르는 이벤트 등록
        body.addEventListener("mousedown", mousedown);
    
        // 클릭한 마우스 떼는 이벤트 함수
        var mouseup = async function(e) {

            selectArea = false;
            // (초기화) 마우스 떼면서 마우스무브 이벤트 삭제
            body.removeEventListener("mousemove", mousemove);
            // (초기화) 스크린샷을 위해 생성한 객체 삭제
            screenshot.parentNode.removeChild(screenshot);
            screenBg.parentNode.removeChild(screenBg);
            var x = e.clientX;
            var y = e.clientY;
            var top = Math.min(y, startY);
            var left = Math.min(x, startX);
            var width = Math.max(x, startX) - left;
            var height = Math.max(y, startY) - top;
            html2canvas(document.body).then((canvas)=> { //전체 화면 캡쳐
                    // 선택 영역만큼 crop
                    if(width != 0){
                        var img = canvas.getContext('2d').getImageData(left, top, width, height);
                        var c = document.createElement("canvas");
                        c.width = width;
                        c.height = height;
                        c.getContext('2d').putImageData(img, 0, 0);
                        canvas.toBlob(blob => navigator.clipboard.write([new ClipboardItem({"image/png": blob})]))
    
                        save(c); // crop한 이미지 저장
                    }else{
                        alert('캡쳐 영역이 없습니다.')
                    }
                    
                }
            );
            body.removeEventListener("mouseup", mouseup);
            // 마우스 커서 기본으로 변경
            document.querySelector("body").classList.remove("edit_cursor");
        }
        body.addEventListener("mouseup", mouseup);
    
        // 마우스무브 이벤트 함수
        function mousemove(e) {
            var x = e.clientX;
            var y = e.clientY;
            screenshot.style.left = x;
            screenshot.style.top = y;
            if (selectArea) { //캡쳐 영역 선택 그림
                var top = Math.min(y, startY);
                var right = width - Math.max(x, startX);
                var bottom = height - Math.max(y, startY);
                var left = Math.min(x, startX);
                screenBg.style.borderWidth = top + 'px ' + right + 'px ' + bottom + 'px ' + left + 'px';
            }
        }
        body.addEventListener("mousemove", mousemove);
        
        // 캡쳐한 이미지 저장
        function save(canvas) { 
            canvas.toBlob(blob => navigator.clipboard.write([new ClipboardItem({"image/png": blob})]))

            if (navigator.msSaveBlob) {
                var blob = canvas.msToBlob();
                return navigator.msSaveBlob(blob, '파일명.jpg');
            
            } else {
            const el = document.createElement('a');
                el.href = canvas.toDataURL("image/jpeg");
                el.download = '파일명.jpg';
                el.click();
            }
        }
    }catch(error){
        console.log(error)
    }
    
}

export {capture}